import axiosInstance from '../http/axios_instance'
const http = axiosInstance('/protected/admin', null, '/dashboard')

const getReportDetails = (org_id, search) =>
	search
		? http.get('/report_details/' + org_id + '?search=' + search)
		: http.get('/report_details/' + org_id)
const getAllReportDetails = filters => http.post('/all_report_details', filters)
const getManagementReports = (org_id, body) =>
	http.post('/management_reports/' + org_id, body)
const downloadCSV = filters => http.post('/reports_csv', filters)

const getReportsData = body => {
	console.log('[admin_report] → POST /protected/admin/reports_data', body)
	const req = http.post('/reports_data', body)
	req
		.then(res => console.log('[admin_report] ← reports_data', res && res.data))
		.catch(err =>
			console.error(
				'[admin_report] ✗ reports_data',
				err && (err.response ? err.response.status : err.message),
			),
		)
	return req
}

export default {
	getReportDetails,
	getAllReportDetails,
	getManagementReports,
	downloadCSV,
	getReportsData,
}
